<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    /*
    showModalStatut() {
      this.$refs.modalStatut.showModal();
    },
    onChangeStatut(candidature) {
      this.setCurrentCandidature(candidature);
    },
     */
  },
};
</script>
